<template>
	<Layout>
      	<PageHeader :title="title" :items="items" />

		<div class="col-lg-12">
			<div class="row">
					<!-- <div class="col-lg-4 col-md-6">
						<div class="card card-block card-stretch card-height">
							<div class="card-body">
								<div class="d-flex align-items-center justify-content-between">
									<div class="mm-cart-text">
										<p class="mb-0 text-danger">Active Tests</p>
										<h4 class="font-weight-400">50</h4>
									</div>
									<div class="mm-cart-image text-primary" style="height: 52px; width: 50px;">
										<i class="fa fa-3x fa-hospital"></i>
									</div>
								</div>
							</div>
						</div>
					</div> -->

					<div class="col-md-4">
						<div class="card mini-stats-wid">
							<div class="card-body">
								<div class="media mb-3">
									<div class="media-body">
									<p class="text-muted fw-medium mb-2 font-size-18">Bookings</p>
									</div>

									<div class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-primary">
									<span class="avatar-title">
										<i class="fas fa-calendar-plus font-size-20"></i>
									</span>
									</div>
								</div>

								<div class="media mb-2">
									<div class="media-body">
									<p class="text-muted fw-medium mb-2">Today</p>
									</div>

									<div class="align-self-center ">
									<span class="float-end me-3">
										<h4 class="mb-0 font-size-16">{{ todays_bookings }}</h4>
									</span>
									</div>
								</div>

								<div class="media mb-2">
									<div class="media-body">
									<p class="text-muted fw-medium mb-2">This week</p>
									</div>

									<div class="align-self-center ">
									<span class="float-end me-3">
										<h4 class="mb-0 font-size-16">{{ this_week_bookings }}</h4>
									</span>
									</div>
								</div>

								<div class="media mb-2">
									<div class="media-body">
									<p class="text-muted fw-medium mb-2">This month</p>
									</div>

									<div class="align-self-center ">
									<span class="float-end me-3">
										<h4 class="mb-0 font-size-16">{{ this_month_bookings }}</h4>
									</span>
									</div>
								</div>

								<div class="media">
									<div class="media-body">
									<p class="text-muted fw-medium mb-2">Total</p>
									</div>

									<div class="align-self-center ">
									<span class="float-end me-3">
										<h4 class="mb-0 font-size-16">{{ total_bookings }}</h4>
									</span>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="col-md-4">
						<div class="card mini-stats-wid">
							<div class="card-body">
								<div class="media mb-3">
									<div class="media-body">
									<p class="text-muted fw-medium mb-2 font-size-18">Lab Collections</p>
									</div>

									<div class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-primary">
									<span class="avatar-title">
										<i class="fa fa-3x fa-hospital"></i>
									</span>
									</div>
								</div>

								<div class="media mb-2">
									<div class="media-body">
									<p class="text-muted fw-medium mb-2">Today</p>
									</div>

									<div class="align-self-center ">
									<span class="float-end me-3">
										<h4 class="mb-0 font-size-16">{{ todays_lab_bookings }}</h4>
									</span>
									</div>
								</div>

								<div class="media mb-2">
									<div class="media-body">
									<p class="text-muted fw-medium mb-2">This week</p>
									</div>

									<div class="align-self-center ">
									<span class="float-end me-3">
										<h4 class="mb-0 font-size-16">{{ this_week_lab_bookings }}</h4>
									</span>
									</div>
								</div>

								<div class="media mb-2">
									<div class="media-body">
									<p class="text-muted fw-medium mb-2">This month</p>
									</div>

									<div class="align-self-center ">
									<span class="float-end me-3">
										<h4 class="mb-0 font-size-16">{{ this_month_lab_bookings }}</h4>
									</span>
									</div>
								</div>

								<div class="media">
									<div class="media-body">
									<p class="text-muted fw-medium mb-2">Total</p>
									</div>

									<div class="align-self-center ">
									<span class="float-end me-3">
										<h4 class="mb-0 font-size-16">{{ total_lab_bookings }}</h4>
									</span>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="col-md-4">
						<div class="card mini-stats-wid">
							<div class="card-body">
								<div class="media mb-3">
									<div class="media-body">
									<p class="text-muted fw-medium mb-2 font-size-18">Home Collections</p>
									</div>

									<div class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-primary">
									<span class="avatar-title">
										<i class="fa fa-3x fa-home"></i>
									</span>
									</div>
								</div>

								<div class="media mb-2">
									<div class="media-body">
									<p class="text-muted fw-medium mb-2">Today</p>
									</div>

									<div class="align-self-center ">
									<span class="float-end me-3">
										<h4 class="mb-0 font-size-16">{{ todays_home_bookings }}</h4>
									</span>
									</div>
								</div>

								<div class="media mb-2">
									<div class="media-body">
									<p class="text-muted fw-medium mb-2">This week</p>
									</div>

									<div class="align-self-center ">
									<span class="float-end me-3">
										<h4 class="mb-0 font-size-16">{{ this_week_home_bookings }}</h4>
									</span>
									</div>
								</div>

								<div class="media mb-2">
									<div class="media-body">
									<p class="text-muted fw-medium mb-2">This month</p>
									</div>

									<div class="align-self-center ">
									<span class="float-end me-3">
										<h4 class="mb-0 font-size-16">{{ this_month_home_bookings }}</h4>
									</span>
									</div>
								</div>

								<div class="media">
									<div class="media-body">
									<p class="text-muted fw-medium mb-2">Total</p>
									</div>

									<div class="align-self-center ">
									<span class="float-end me-3">
										<h4 class="mb-0 font-size-16">{{ total_home_bookings }}</h4>
									</span>
									</div>
								</div>
							</div>
						</div>
					</div>

			</div>
		</div>
		<div class="row mb-5">
         <div class="col-md-6">
            <div class="card h-100">
               <div class="card-body">
                  <h4 class="font-size-20  p-3 mb-3">Collections</h4>
                  <apexchart
                    class="apex-charts"
                    height="320"
                    type="pie"
                    dir="ltr"
                    :series="pieChart.series"
                    :options="pieChart.chartOptions"
                  ></apexchart>
               </div>
            </div>
         </div>


         <div class="col-md-6">
            <div class="card h-100">
               <div class="card-body">
                  <h4 class="font-size-20  p-3 mb-3">Bookings</h4>
                  <apexchart
                    class="apex-charts"
                    height="350"
                    type="area"
                    dir="ltr"
                    :series="splineAreaChart.series"
                    :options="splineAreaChart.chartOptions"
                  ></apexchart>
               </div>
            </div>
         </div>
      </div>
	</Layout>
</template>

<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";

// import Stat from "@/components/widgets/stat";

/**
 * Dashboard Component
 */
export default {
   page: {
      title: "Dashboard",
      meta: [
         {
            name: "description",
            content: appConfig.description,
         },
      ],
   },
   components: {
      Layout,
      PageHeader,
    //   Stat,
   },
   data() { 
      return {
         title: "Dashboard",
         items: [
            {
               text: "Dashboard",
               active: true,
            },        
         ],

		todays_bookings: '0',
		this_week_bookings: '0',
		this_month_bookings: '0',
		total_bookings: '0',

		todays_lab_bookings: '0',
		this_week_lab_bookings: '0',
		this_month_lab_bookings: '0',
		total_lab_bookings: '0',

		todays_home_bookings: '0',
		this_week_home_bookings: '0',
		this_month_home_bookings: '0',
		total_home_bookings: '0',

		lab_percentage: '',
		home_percentage: '',





		 pieChart: {
            series: [],
            chartOptions: {
               labels: ["Lab collection", "Home collection"],
               colors: ["#34c38f", "#556ee6"],
               legend: {
                  show: true,
                  position: 'bottom',
                  horizontalAlign: 'center',
                  verticalAlign: 'middle',
                  floating: false,
                  fontSize: '14px',
                  offsetX: 0
               },
               responsive: [{
                  breakpoint: 600,
                  options: {
                     chart: {
                        height: 240
                     },
                     legend: {
                        show: false
                     },
                  }
               }]
            }
         }, // pieChart ends

         splineAreaChart: {
            series: [{
               name: 'Bookings',
               data: []
            }],
            chartOptions: {
               chart: {
                  toolbar: {
                     show: false
                  }
               },
               dataLabels: {
                  enabled: false
               },
               stroke: {
                  curve: 'smooth',
                  width: 3,
               },
               colors: ['#34c38f'],
               xaxis: {
                  type: 'month',
                  categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
               },
               grid: {
                  borderColor: '#f1f1f1',
               },
               tooltip: {
                  x: {
                     format: 'dd/MM/yy HH:mm'
                  },
               }
			   
            }
         }
		}
	},
	mounted() { },
	created() {
		this.fetchDashboard();
	},

	methods: {
		fetchDashboard() {
			let url = "lab/dashboard";
			this.getToken();
			this.loading = true;
			this.$axios
				.get(url, { headers: { Authorization: "Bearer " + this.token } })
				.then((res) => {
					var data = res.data.data;
					console.log(data);

					if(data){
						//Bookings
						this.todays_bookings = data.todays_bookings;
						this.this_week_bookings = data.this_week_bookings;
						this.this_month_bookings = data.this_month_bookings;
						this.total_bookings = data.total_bookings;

						//Lab Bookings
						this.todays_lab_bookings = data.todays_lab_bookings;
						this.this_week_lab_bookings = data.this_week_lab_bookings;
						this.this_month_lab_bookings = data.this_month_lab_bookings;
						this.total_lab_bookings = data.total_lab_bookings;

						//Home Bookings
						this.todays_home_bookings = data.todays_home_bookings;
						this.this_week_home_bookings = data.this_week_home_bookings;
						this.this_month_home_bookings = data.this_month_home_bookings;
						this.total_home_bookings = data.total_home_bookings;

						//Piechart
						this.lab_percentage = data.lab_percentage;
						this.home_percentage = data.home_percentage;
						this.pieChart.series = [this.lab_percentage, this.home_percentage];

						//splineAreaChart
						this.bookings_month = data.bookings_month;
						this.splineAreaChart.series = [{
						name: 'Bookings',
						data: this.bookings_month
						}];

					}

					

				})
				.catch((error) => {

					if (error.response) {
						if (error.response.data.message) {

							if (typeof error.response.data.message === 'object') {
								console.log(error.response.status);
							} else {
								this.$swal("", error.response.data.message, "error");
							}
						}
						else {
							this.$swal("", "Something went wrong", "error");
						}
					} else {
						this.$swal("", "Something went wrong", "error");
					}

				})
				.finally(() => (this.loading = false));
		},
		getToken() {
			if (localStorage.getItem('medicino_lab')) {
				var medicino_lab = JSON.parse(localStorage.getItem('medicino_lab'));
				if (medicino_lab.token) {
					this.token = medicino_lab.token;
				} else {
					this.$swal("", "Failed to fetch token, please login again", "error");
					this.$router.push({ name: "login" });
				}

			} else {
				this.$swal("", "Session expired, please login again", "error");
				this.$router.push({ name: "login" });
			}
		},
	}
}


</script>

